/* DeviceTypeEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("../CommonEditor");
const getDefaultCreateValue = require("./mapDataUtil");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class DeviceTypeEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
    }

    _init() {
        const dropDownData = _.get(this._itemData, "deviceTypeOptions", []);
        this.input.setOptions(dropDownData);
        super._init();
    }

    applyValue(item, state) {
        super.applyValue(item, state);
        item.netBoxName = getDefaultCreateValue(
            item.vendor,
            item.deviceType,
            item.vendorOptions,
            item.deviceTypeOptions
        );
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: true,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }

    show() {}
    hide() {}
}

module.exports = DeviceTypeEditor;
